import {ATTENDANCE_STATUS} from '../../CodeMaster'
import React from 'react'
import styled, {css} from 'styled-components'
import {Nullable} from '../../app/TypeHelpers'

interface Props {
    meetingAttendanceStatus: Nullable<ATTENDANCE_STATUS>
}

const AdminMeetingAttendanceStatusTag: React.FC<Props> = props =>
    <StyledStatusTag {...props}>{props.meetingAttendanceStatus?.label || '未回答'}</StyledStatusTag>

AdminMeetingAttendanceStatusTag.displayName = 'ReservationStatusTag'
export default AdminMeetingAttendanceStatusTag

const StyledStatusTag = styled.div<Props>`
  width: 100px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  display: inline-block;
  border-radius: 10px / 50%;
  background: ${props => {
    switch (props.meetingAttendanceStatus) {
      case ATTENDANCE_STATUS.ATTEND:
        return css`rgb(167, 211, 236)`
      case ATTENDANCE_STATUS.PROXY_ATTEND:
        return css`rgb(206, 231, 244)`
      case ATTENDANCE_STATUS.ABSENT:
        return css`rgb(250, 210, 145)`
      default:
        return css`rgb(236, 236, 236)`
    }
  }};
`

